export * from './department-group-carousel-item';
export * from './department-group-details';

import { DepartmentGroupCarouselItemComponent } from './department-group-carousel-item';
import { DepartmentGroupDetailsComponent } from './department-group-details';


export const DepartmentGroupAtoms = [
    DepartmentGroupCarouselItemComponent,
    DepartmentGroupDetailsComponent
]